<template>
    <div>
        <div
            id="connect-modal"
            class="modal absolute-modal"
            aria-labelledby="connect-modal"
            role="dialog"
            aria-modal="true"
            v-if="showAddCardModal"
        >
            <div class="modal-overlay" aria-hidden="true"></div>
            <div
                class="inner rounded-lg bg-white shadow border border-gray-200"
                style="-webkit-transform: translate3d(0, 0, 0)"
            >
                <div class="connect-progress">
                    <div
                        class="connect-progress-bar"
                        :style="'width:' + progressPercent + '%'"
                    ></div>
                </div>
                <a
                    href="#"
                    class="modal-close-btn"
                    role="button"
                    @click.prevent="close"
                    id="hs-wallet-close-connect-modal"
                >
                    <i class="fal fa-times"></i>
                </a>
                <!-- CONNECT STEPS -->
                <div id="connect-steps-section" class="connect-steps">
                    <!-- CONNECT STEP -->

                    <div
                        id="connect-step-1"
                        class="connect-step"
                        v-show="connectStep === 1"
                    >
                        <div class="modal-body">
                            <div
                                class="text-center mb-4 mx-auto flex justify-center items-center rounded-full bg-gray-100 w-14 h-14"
                            >
                                <i class="far fa-credit-card text-2xl"></i>
                            </div>
                            <label class="mb-5 text-center block">
                                <span
                                    class="block w-full mb-8 text-base lg:text-xl"
                                >
                                    Let's add a card to
                                    <div class="inline-block custom-select">
                                        <UiInput
                                            name="account_user"
                                            id="account_user"
                                            label="Account User"
                                            :options="{ hideLabel: true }"
                                        >
                                            <template #input>
                                                <select
                                                    class="w-full appearance-none text-xl"
                                                    v-model="accountUserForCard"
                                                    style="max-width: 180px"
                                                    @change="setWalletUser"
                                                >
                                                    <option
                                                        v-if="
                                                            chooseUsers.length >
                                                            1
                                                        "
                                                        value=""
                                                    ></option>
                                                    <option
                                                        v-for="user in chooseUsers"
                                                        :value="user.id"
                                                    >
                                                        {{ user.name }}
                                                    </option>
                                                </select>
                                            </template>
                                        </UiInput>
                                    </div>
                                    's wallet
                                </span>
                            </label>
                        </div>
                        <div
                            class="modal-footer flex !flex-row flex-wrap justify-center items-center bg-gray-50 gap-2"
                        >
                            <div class="w-full" v-show="errors.length > 0">
                                <Errors :errors="errors" />
                            </div>
                            <a
                                href="#connect-step-2"
                                class="btn-base btn-dark !w-48"
                                @click.prevent="gotoStep(2)"
                                id="hs-wallet-connect-next"
                            >
                                Next
                            </a>
                        </div>
                    </div>

                    <!-- END CONNECT STEP -->
                    <!-- CONNECT STEP -->

                    <div
                        id="connect-step-2"
                        class="connect-step"
                        v-show="connectStep === 2"
                    >
                        <div class="modal-body">
                            <h4 class="text-xl lg:text-2xl mb-8 text-center">
                                How Do You Want to Manage this Account?
                            </h4>
                            <div
                                class="grid grid-cols-2 gap-2 md:gap-4 justify-items-center md:flex justify-center items-center mb-10 block-toggles w-full"
                            >
                                <label
                                    class="flex justify-center items-center flex-col cursor-pointer w-full md:w-auto md:mx-3"
                                >
                                    <input
                                        type="radio"
                                        class="form-radio hide"
                                        value="connect_to_bank"
                                        v-model="howToAddCard"
                                    />
                                    <span
                                        class="flex group justify-center items-center flex-col border-gray-300 border rounded-md text-xs font-semibold md:text-base p-3 lg:p-6 text-center w-full md:w-56 hover:bg-gray-100"
                                    >
                                        <span class="fa-stack fa-xl md:fa-2xl">
                                            <i
                                                class="fas fa-circle fa-stack-2x group-hover:!text-white"
                                            ></i>
                                            <i
                                                class="far fa-university fa-stack-1x fa-inverse"
                                            ></i>
                                        </span>

                                        Connect Directly
                                        <br />
                                        Through Your Bank
                                    </span>
                                </label>
                                <label
                                    class="flex justify-center items-center flex-col cursor-pointer w-full md:w-auto md:mx-3"
                                >
                                    <input
                                        type="radio"
                                        class="form-radio hide"
                                        value="add_card_manually"
                                        v-model="howToAddCard"
                                    />
                                    <span
                                        class="group flex justify-center items-center flex-col border-gray-300 border rounded-md text-xs font-semibold md:text-base p-3 lg:p-6 text-center w-full md:w-56 hover:bg-gray-100"
                                    >
                                        <span class="fa-stack fa-xl md:fa-2xl">
                                            <i
                                                class="fas fa-circle fa-stack-2x group-hover:!text-white"
                                            ></i>
                                            <i
                                                class="far fa-credit-card fa-stack-1x fa-inverse"
                                            ></i>
                                        </span>

                                        I'll Add This
                                        <br />
                                        Card Manually
                                    </span>
                                </label>
                            </div>

                            <div class="text-center mb-10 lg:px-4 prose">
                                <p
                                    class="text-base lg:text-lg font-semibold leading-6 mb-5"
                                >
                                    Connect to supported institutions to import
                                    your information automatically.
                                </p>
                                <p class="text-sm lg:text-base mb-5">
                                    Not comfortable connecting? No problem - you
                                    can manually manage all of your accounts in
                                    My10x with very little difference in
                                    experience.
                                </p>
                                <p class="text-sm lg:text-base">
                                    <a
                                        href="/security"
                                        class="link-base link-10x-orange"
                                        target="_blank"
                                        id="hs-wallet-connect-see-privacy-policy"
                                    >
                                        <i class="fas fa-lock-alt mr-1"></i>
                                        Learn How We Keep Your Data Safe
                                    </a>
                                </p>
                            </div>
                        </div>
                        <div
                            class="modal-footer flex !flex-row flex-wrap justify-between md:justify-end items-center bg-gray-50 gap-2"
                        >
                            <div
                                class="w-full"
                                v-show="errors.length > 0"
                            >
                                <Errors :errors="errors" />
                            </div>
                            <a
                                href="#connect-step-2"
                                @click.prevent="gotoStep(1)"
                                style="margin-right: auto"
                                class="btn-base btn-white !w-24 md:!w-48 !bg-gray-50"
                                id="hs-wallet-connect-back"
                            >
                                &larr; Back
                            </a>
                            <a
                                href="#connect-step-3"
                                class="btn-base btn-dark !w-24 md:!w-48"
                                @click.prevent="gotoStep(3)"
                                id="hs-wallet-connect-next"
                            >
                                Next
                            </a>
                        </div>
                    </div>

                    <!-- END CONNECT STEP -->
                    <!-- CONNECT STEP -->

                    <div
                        id="connect-step-3"
                        class="connect-step"
                        v-show="connectStep === 3"
                    >
                        <!-- CONNECT TO BANK -->
                        <div
                            class="w-full"
                            v-if="howToAddCard === 'connect_to_bank'"
                        >
                            <div v-show="showInstitutionsDropdown">
                                <div class="modal-body">
                                    <h4
                                        class="text-xl lg:text-2xl mb-8 text-center"
                                    >
                                        What Bank Do You Wish To Connect To?
                                    </h4>
                                    <div
                                        class="fin-selects mb-5 grid grid-cols-4 gap-2 w-full max-w-2xl"
                                    >
                                        <label
                                            class="cursor-pointer px-1 py-2 lg:py-4 hover:bg-blue-50 shadow ring-1 ring-black ring-opacity-5 md:rounded-lg"
                                            :class="{
                                                'bg-blue-50': bank.active,
                                            }"
                                            v-for="bank in filteredBanks"
                                            :key="'bank-' + bank.id"
                                            @click="
                                                setBankActive(bank);
                                                institutionCode =
                                                    bank.institution_code;
                                            "
                                        >
                                            <div class="center">
                                                <input
                                                    type="radio"
                                                    name="institution_code"
                                                    class="sr-only"
                                                    :value="
                                                        bank.institution_code
                                                    "
                                                />
                                                <img
                                                    :src="
                                                        bank.institution
                                                            .small_logo_url
                                                    "
                                                    :alt="bank.name"
                                                    class="m-auto mb-2 rounded-full h-8 w-8 lg:h-12 lg:w-12"
                                                />
                                                <div
                                                    class="flex items-center text-center justify-center"
                                                >
                                                    <span
                                                        class="text-xs md:text-sm font-medium text-gray-500 leading-tight mb-1"
                                                    >
                                                        {{ bank.name }}
                                                    </span>
                                                </div>
                                            </div>
                                        </label>
                                    </div>
                                    <p
                                        class="mb-5 block text-center w-3/4 mx-auto text-sm"
                                    >
                                        At this time, these are the only
                                        institutions we support connections to.
                                        Any other institutions will have to be
                                        <a
                                            href="#connect-step-2"
                                            @click.prevent="gotoStep(2)"
                                            class="link-base link-10x-orange !px-0"
                                            id="hs-wallet-connect-manually"
                                        >
                                            managed manually.
                                        </a>
                                    </p>
                                </div>
                                <div
                                    class="modal-footer flex !flex-row flex-wrap justify-between md:justify-end items-center bg-gray-50"
                                >
                                    <div
                                        class="w-full"
                                        v-show="errors.length > 0"
                                    >
                                        <Errors :errors="errors" />
                                    </div>
                                    <a
                                        href="#connect-step-2"
                                        @click.prevent="handleBack"
                                        style="margin-right: auto"
                                        class="btn-base btn-white !w-24 md:!w-48 !bg-gray-50"
                                        id="hs-wallet-connect-back"
                                    >
                                        &larr; Back
                                    </a>
                                    <button
                                        @click.prevent="getWidgetUrl"
                                        class="btn-base btn-dark !w-48"
                                        id="hs-wallet-connect-next"
                                    >
                                        Connect to Bank
                                    </button>
                                </div>
                            </div>
                            <div
                                id="connect-widget"
                                class="flex justify-center items-center relative"
                                style="width: 100%; height: 600px"
                                v-show="
                                    !completedConnect &&
                                    !showInstitutionsDropdown
                                "
                            >
                                <div
                                    class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center text-3xl text-gray-500"
                                    v-if="loadingConnectWidget"
                                >
                                    <i class="fas fa-spinner-third fa-spin"></i>
                                </div>
                            </div>
                            <div v-if="completedConnect && !finshedSyncAccount">
                                <div class="modal-body">
                                    <div class="text-center mb-5">
                                        <i
                                            class="far fa-spinner-third text-7xl text-orange fa-spin"
                                        ></i>
                                    </div>

                                    <h3
                                        class="modal-title mb-5 text-center"
                                        id="add-card-modal-title"
                                    >
                                        Syncing Your {{ chosenBank }} Account
                                    </h3>
                                    <p class="mb-3 text-center">
                                        Hang tight!
                                        <br />
                                        We need about a minute or so to finish
                                        syncing your
                                        {{ chosenBank }} account.
                                    </p>
                                </div>
                            </div>
                            <div
                                v-if="
                                    finshedSyncAccount &&
                                    !showAccountSyncDelayMessage
                                "
                            >
                            </div>
                            <div v-if="showAccountSyncDelayMessage">
                                <div class="modal-body">
                                    <div
                                        class="text-center mb-4 mx-auto flex justify-center items-center rounded-full bg-gray-100 w-14 h-14"
                                    >
                                        <i
                                            class="fal fa-info-circle text-2xl"
                                        ></i>
                                    </div>

                                    <div class="text-center mb-10 px-4">
                                        <h3 class="mb-4 text-2xl font-bold">
                                            {{ chosenBank }} Account Sync in
                                            Progress
                                        </h3>
                                        <p class="text-base mb-5">
                                            Thanks for connecting your
                                            {{ chosenBank }} account to My10x.
                                            The accounts are still being synced
                                            and is taking longer than expected.
                                        </p>
                                        <p class="text-base mb-5">
                                            We will keep checking for the new
                                            accounts every few minutes within
                                            the next 12 hours and notify you
                                            when it is complete.
                                        </p>
                                        <p class="text-base mb-5">
                                            You may close this window and
                                            continue using My10x, and we'll let
                                            you know when your accounts have
                                            finished syncing in the background.
                                        </p>
                                    </div>
                                </div>
                                <div
                                    class="modal-footer justify-start bg-gray-50"
                                >
                                    <button
                                        class="btn-base btn-dark w-48"
                                        @click="finishAddingCard"
                                        id="hs-wallet-connect-finished"
                                    >
                                        Finished
                                    </button>
                                </div>
                            </div>
                        </div>
                        <!-- // END CONNECT TO BANK -->
                        <!-- MANUALLY ADD CARD -->
                        <div
                            id="manual-card-section"
                            class="w-full h-full"
                            v-if="howToAddCard === 'add_card_manually'"
                        >
                            <ManualCardEntry
                                :accountUserForCard="accountUserForCard"
                                :wallet="wallet"
                                :cards="bankCards"
                                :banks="banks"
                                @gotoStep="gotoStep"
                                @finished="finishAddingCard"
                                @setProgress="setProgress"
                            />
                        </div>
                        <!-- // END MANUALLY ADD CARD -->
                    </div>

                    <!-- // END CONNECT STEP -->
                </div>
                <!-- // END CONNECT STEPS -->
            </div>
        </div>
        <!--
        <ChallengesModal
            :member="member"
            show="showChallengeModal"
            @success="handleChallengeSuccess"
        />-->
    </div>
</template>

<script>
import * as widgetSdk from '@mxenabled/web-widget-sdk';
import ManualCardEntry from '@/components/wallet/modals/manual-card-entry.vue';
import ChallengesModal from '@/components/wallet/modals/challenges.vue';
import Errors from '@/components/errors.vue';
import UiInput from '@/components/ui/inputs/ui-input.vue';

export default {
    name: 'ConnectModal',
    props: {
        wallet: Object,
        cards: Array,
        users: Array,
        banks: Array,
        showAddCardModal: Boolean,
        setFinshedSyncAccount: Boolean,
        setFixUnresolved: Boolean,
        setHowToAddCard: String,
        step: Number,
        activeUser: Object,
        connectType: String,
        member: Object,
    },
    components: {
        ManualCardEntry,
        ChallengesModal,
        Errors,
        UiInput,
    },
    data: () => ({
        errors: [],
        accountSyncErrors: [],
        connectedAccounts: [],
        addCardStep: 1,
        connectStep: 1,
        loadingConnectWidget: false,
        showThankYouConnectMessage: false,
        showWaitForAccountsOverlay: false,
        showAccountSyncDelayMessage: false,
        showInstitutionsDropdown: false,
        completedConnect: false,
        addCardBtnAction: false,
        saveCardBtnAction: false,
        finshedSyncAccount: false,
        fixUnresolved: false,
        widgetUrl: '',
        currentInstitutionCode: '',
        accountUserForCard: '',
        howToAddCard: '',
        institutionCode: '',
        institution: '',
        connectedCard: '',
        progressPercent: 10,
        showChallengeModal: false,
        mxWidget: null,
        activeBank: null,
    }),
    watch: {
        step(val) {
            this.connectStep = val;
            switch (this.connectStep) {
                case 1:
                    this.completedConnect = false;
                    break;
                case 3:
                    setTimeout(() => {
                        this.connectStep = 3;
                        this.progressPercent = 90;
                    }, 200);
                    break;
            }
        },
        connectType: {
            immediate: true,
            handler(val) {
                if (val === 'memberRequest') {
                    this.connectStep = 3;
                    this.howToAddCard = 'connect_to_bank';
                    this.showInstitutionsDropdown = false;
                    this.showAccountSyncDelayMessage = false;

                    this.$nextTick(() => {
                        this.getWidgetUrl();
                    });
                }
            },
        },
        setFinshedSyncAccount(val) {
            this.finshedSyncAccount = val;
        },
        setHowToAddCard(val) {
            this.howToAddCard = val;
        },
        setFixUnresolved(val) {
            if (val) {
                this.completedConnect = true;
            }
            this.fixUnresolved = val;
        },
        users() {
            if (this.users.length === 1) {
                this.accountUserForCard = this.users[0].id;
                this.connectStep = 2;
                this.progressPercent = 20;
                localStorage.setItem(
                    'accountUserForCard',
                    this.accountUserForCard
                );
            }
        },
        activeUser() {
            if (this.activeUser.hasOwnProperty('id')) {
                this.accountUserForCard = this.activeUser.id;
            }
        },
        showAddCardModal(val) {
            if (this.users.length === 1) {
                this.accountUserForCard = this.users[0].id;
                this.connectStep = 2;
                this.progressPercent = 20;
                localStorage.setItem(
                    'accountUserForCard',
                    this.accountUserForCard
                );
            }
        },
    },
    computed: {
        bankCards() {
            if (this.institution === '') {
                return this.cards;
            } else {
                return this.cards.filter((v) => {
                    return v.issuing_bank.institution_code === this.institution;
                });
            }
        },
        filteredBanks() {
            return this.banks.filter((bank) => {
                return bank.show_in_chooser;
            });
        },
        chosenBank() {
            let bank = this.banks.find((obj) => {
                return obj.institution_code === this.institutionCode;
            });
            return bank ? bank.name : '';
        },
        chooseUsers() {
            if (this.users.length == 1) {
                this.accountUserForCard = this.users[0].id;
            }
            return this.users;
        },
    },
    methods: {
        setProgress(percent) {
            this.progressPercent = percent;
        },
        gotoStep(step) {
            this.errors = [];
            const stepsPercent = {
                2: 20,
                3: 30,
            };

            if (this.connectStep === 1 && step === 2) {
                if (this.accountUserForCard === '') {
                    this.errors.push({ message: 'Please choose a user.' });
                }
            }

            if (this.connectStep === 2 && step === 3) {
                if (this.howToAddCard === '') {
                    this.errors.push({
                        message: 'Please choose a method.',
                    });
                }
            }

            if (this.errors.length === 0) {
                if (step === 3) {
                    this.showInstitutionsDropdown = true;
                }

                this.progressPercent = stepsPercent[step];
                this.connectStep = step;
            }
        },
        setWalletUser() {
            localStorage.setItem('accountUserForCard', this.accountUserForCard);
        },
        presentConnectIframe() {
            let self = this;

            const container = document.getElementById('connect-widget');
            if (!container) {
                console.error('connect-widget container not found in DOM!');
                this.$notify(
                    {
                        group: 'error',
                        title: 'Error',
                        text: 'Unable to initialize connection widget. Please try again.',
                    },
                    4000
                );
                return;
            }

            if (!self.widgetUrl || !self.widgetUrl.url) {
                console.error('Widget URL is invalid:', self.widgetUrl);
                this.$notify(
                    {
                        group: 'error',
                        title: 'Error',
                        text: 'Unable to initialize connection widget. Invalid URL.',
                    },
                    4000
                );
                return;
            }

            try {
                self.mxWidget = new widgetSdk.ConnectWidget({
                    container: '#connect-widget',
                    url: self.widgetUrl.url,
                    iframeTitle: 'Connect',
                    onLoaded: (payload) => {
                        self.loadingConnectWidget = false;
                        self.connectLog('loaded', payload);
                    },
                    onBackToSearch: (payload) => {
                        self.loadingConnectWidget = true;
                        document.getElementById('connect-widget').innerHTML = '';
                        self.connectLog('backToSearch', payload);
                        self.gotoStep(3);
                    },
                    onMemberConnected: (payload) => {
                        self.connectLog('memberConnected', payload);

                        if (self.connectType === 'memberRequest') {
                            self.resyncConnectedAccounts(payload);

                            self.$notify(
                                {
                                    group: 'success',
                                    title: 'Account connected',
                                    text: 'Your institution connection has been reconnected. We will attempt to download your accounts again shortly.',
                                },
                                5000
                            );

                            self.close();
                            self.$emit('addedCard');
                        } else {
                            self.syncConnectedAccounts(payload);
                        }

                        self.mxWidget.unmount();
                        self.mxWidget = null;

                        try {
                            if (import.meta.env.VITE_APP_ENV === 'production') {
                                woopra.track('bank-connected-my10x', {
                                    datetime: new Date(),
                                    bankName: this.institutionCode,
                                    uuid: localStorage.getItem('uuid') || 'unknown',
                                });
                            }
                        } catch (e) {
                            console.error('Woopra tracking error:', e);
                        }
                    },
                    onCreateMemberError: (payload) => {
                        console.error('MX Widget create member error:', payload);
                        self.connectLog('createMemberError', payload);
                        self.$notify(
                            {
                                group: 'error',
                                title: 'Connection Error',
                                text: 'There was an error connecting to your bank. Please try again or contact support.',
                            },
                            10000
                        );
                    },
                    onPrimaryAction: (payload) => {
                        self.connectLog('primaryAction', payload);
                    },
                    onEnterCredentials: (payload) => {
                        self.connectLog('enterCredentials', payload);
                    },
                    onMemberStatusUpdate: (payload) => {
                        self.connectLog('memberStatusUpdate', payload);
                    },
                    onOauthError: (payload) => {
                        console.error('MX Widget oauth error:', payload);
                        self.connectLog('oauthError', payload);
                    },
                    onOauthRequested: (payload) => {
                        self.connectLog('oauthRequested', payload);
                    },
                    onStepChange: (payload) => {
                        self.connectLog('stepChange', payload);
                    },
                    onSubmitMFA: (payload) => {
                        self.connectLog('submitMFA', payload);
                    },
                    onUpdateCredentials: (payload) => {
                        self.connectLog('updateCredentials', payload);
                    },
                });
            } catch (e) {
                console.error('Error initializing MX widget:', e);
            }
        },
        getWidgetUrl() {
            this.errors = [];

            // Skip institution code check for member requests
            if (
                this.connectType !== 'memberRequest' &&
                this.institutionCode === ''
            ) {
                this.errors.push({
                    message: 'Please choose your financial institution.',
                });
                return;
            }

            this.showInstitutionsDropdown = false;
            this.loadingConnectWidget = true;
            this.addCardBtnAction = true;
            let data = { institution_code: this.institutionCode };

            // For member requests (fixing connections), add the required parameters
            if (this.connectType === 'memberRequest') {
                if (!this.member || !this.member.guid) {
                    this.$notify(
                        {
                            group: 'error',
                            title: 'Error',
                            text: 'Unable to reconnect: Member information is missing.',
                        },
                        4000
                    );
                    this.addCardBtnAction = false;
                    return;
                }

                data = {
                    is_member_request: 1,
                    member_guid: this.member.guid,
                };
            }

            ApiService.apiCall(
                '/wallets/' + this.wallet.id + '/url',
                'post',
                data
            )
                .then((response) => {
                    if (typeof response.data.error !== 'undefined') {
                        this.$notify(
                            {
                                group: 'error',
                                title: 'Error',
                                text:
                                    'Bank connect error: ' +
                                    response.data.error.message,
                            },
                            4000
                        );
                    } else {
                        this.widgetUrl = response.data.widget_url;
                        this.presentConnectIframe();
                    }
                    this.addCardBtnAction = false;
                })
                .catch((error) => {
                    this.$root.handleHttpStatus(error);
                    this.addCardBtnAction = false;
                });
        },
        connectLog(type, payload) {
            ApiService.apiCall(
                '/wallets/' + this.wallet.id + '/connect-log',
                'post',
                {
                    status: type,
                    metadata: payload,
                }
            );
        },
        setBankActive(bank) {
            if (this.activeBank) {
                this.activeBank.active = false;
            }
            bank.active = true;
            this.activeBank = bank;
        },
        syncConnectedAccounts(response) {
            if (!this.completedConnect) {
                const data = {
                    user: this.accountUserForCard,
                    user_guid: response.user_guid,
                    member_guid: response.member_guid,
                };

                this.showWaitForAccountsOverlay = true;

                ApiService.apiCall(
                    '/wallets/' + this.wallet.id + '/accounts-sync/',
                    'post',
                    data
                )
                    .then((response) => {
                        const guid = response.data.guid;
                        this.completedConnect = true;
                        this.startAccountSyncTimer(guid);
                    })
                    .catch((response) => {
                        this.$root.handleHttpStatus(response);
                    });
            }
        },
        resyncConnectedAccounts(payload) {
            const data = {
                user_guid: payload.user_guid,
                member_guid: payload.member_guid,
            };

            ApiService.apiCall(
                '/wallets/' + this.wallet.id + '/accounts-resync/',
                'post',
                data
            )
                .then(() => {
                })
                .catch((error) => {
                    this.$root.handleHttpStatus(error);
                });
        },
        handleNext() {
            if (this.setHowToAddCard !== '') {
                this.gotoStep(3);
            } else {
                this.gotoStep(2);
            }
        },
        handleBack() {
            if (this.setHowToAddCard !== '') {
                this.gotoStep(1);
            } else {
                this.gotoStep(2);
            }
        },
        startAccountSyncTimer(guid) {
            setTimeout(() => {
                this.syncNewAccounts(guid);
            }, 65000);
        },
        syncNewAccounts(guid) {
            ApiService.apiCall(
                '/wallets/' + this.wallet.id + '/new-accounts-sync/' + guid,
                'get'
            )
                .then((response) => {
                    this.finshedSyncAccount = true;

                    let rewardsMessage = response.data.has_rewards
                        ? 'Your rewards will sync automatically each night.'
                        : 'You will need to manually enter your rewards balance.';

                    this.$notify(
                        {
                            group: 'success',
                            title: 'Success',
                            text:
                                'Your rewards program has been created. ' +
                                rewardsMessage,
                        },
                        10000
                    );

                    if (response.data.accounts.length > 0) {
                        this.finishAddingCard();
                    } else {
                        this.showAccountSyncDelayMessage = true;
                    }
                })
                .catch((response) => {
                    this.finshedSyncAccount = true;
                    this.$root.handleHttpStatus(response);
                });
        },
        handleChallengeSuccess() {
            /**
             * TODO
             */
            // if (response.data.member.connection_status === 'CHALLENGED') {
            // this.member = response.data.member
            // this.showChallengeModal = true;
            // }
        },
        finishAddingCard() {
            this.resetStepData();
            this.$emit('addedCard');
        },
        toggleManualCardEntry() {
            if (this.connectedCard === 'manual') {
                this.gotoStep(2);
            }
        },
        resetStepData() {
            this.accountUserForCard = '';
            this.howToAddCard = '';
            this.finshedSyncAccount = false;
            this.loadingConnectWidget = false;
            this.showThankYouConnectMessage = false;
            this.showWaitForAccountsOverlay = false;
            this.showAccountSyncDelayMessage = false;
            this.completedConnect = false;
            this.progressPercent = 10;
            this.connectStep = 1;
        },
        close() {
            if (this.mxWidget) {
                this.mxWidget.unmount();
            }
            this.resetStepData();
            this.$emit('close');
        },
    },
    created() {},
    mounted() {},
};
</script>
<style lang="scss" scoped>
.connect-progress {
    width: 100%;
    height: 5px;
    position: absolute;
    top: -1px;
    left: 0;
    z-index: 300;
    overflow: hidden;
    border-radius: 6px;
}
.connect-progress-bar {
    height: 5px;
    position: absolute;
    top: 0;
    left: 0;
    background-color: #ff2100;
    transition: width 0.35s linear;
}
.how-to-connect-choice {
    @apply text-center
    px-3
    py-2
    block
    border-2 border-orange
    cursor-pointer
    hover:bg-orange
    hover:text-white
    transition-colors
    duration-75;

    &.active {
        @apply bg-orange
        text-white;
    }
}
.fadeInOut-enter-active,
.fadeInOut-leave-active {
    transition: opacity 0.8s;
    opacity: 1;
}
.fadeInOut-enter,
.fadeInOut-leave-to {
    opacity: 0;
}
.fadeOut-enter-active,
.fadeOut-leave-active {
    transition: opacity 0.8s;
}
.fadeOut-enter,
.fadeOut-leave-to {
    opacity: 0;
}
</style>
